export enum AuthTypeEnums {
	CREDIT_CARD = 'EC',
}
